<script setup>
import { useRegionalFormat } from 'shared/composables/useRegionalFormat';

const { formatWeekday } = useRegionalFormat();

const calendarWeeks = Array.from({ length: 7 }).map((_, i) => {
  // Jan 1, 2024 is a Monday, so we can use it as a base to get Mon-Sun
  const date = new Date(2024, 0, 1 + i);
  return {
    id: i + 1,
    label: formatWeekday(date, 'narrow'),
  };
});
</script>

<template>
  <div class="max-w-md mx-auto grid grid-cols-7 gap-2">
    <div
      v-for="day in calendarWeeks"
      :key="day.id"
      class="flex items-center justify-center font-medium text-sm w-9 h-7 py-1.5 px-2"
    >
      {{ day.label }}
    </div>
  </div>
</template>
